import {ChangeDetectorRef, Component, Input} from '@angular/core';
import {BlockBaseComponent} from "../../scene-blocks/block-base/block-base.component";
import {isHostDevOrLocal} from "../../../../common";
import {IEffectName, IEffectTypeAny} from "../../../../interfaces";
import {TranslocoService} from "@ngneat/transloco";
import {FieldConfig} from "../../../../interfaces/field.interface";
import {StoreSelectorsService} from "../../../../services";
import * as _ from "lodash";

@Component({
    selector: 'app-block-effect-props',
    templateUrl: './block-effect-props.component.html',
    styleUrls: ['./block-effect-props.component.scss']
})

export class BlockEffectPropsComponent extends BlockBaseComponent {
    effectStorePathRoot;
    effect: IEffectName;
    isHostDevOrLocal;

    @Input()
    set effectName(i_effectName) {
        this.effect = i_effectName;
        this.effectStorePathRoot = `Data[0].${this.effect}[0]`;
    }

    constructor(
        private translocoService: TranslocoService, 
        public override storeSelector: StoreSelectorsService,
        private cd: ChangeDetectorRef,
    ) {
        super(storeSelector);
        this.isHostDevOrLocal = isHostDevOrLocal();
    }

    override preInit() {
    }

    override componentInit() {
        super.componentInit();
    }

    override componentStoreUpdates() {
        this.initApplyStoreToDynamic(true);
        if (this.sceneItemSwitched) {
            // this.cd.detectChanges();
        }
        super.componentStoreUpdates();
    }

    override initApplyStoreToDynamic(applyStoreToDynamic: boolean = false) {
        this.uiConfigInit.forEach((k) => {
            if (_.isUndefined(k.storePath)) return;
            k.storePath = `Data[0].${this.effect}[0].$.${k.name}`;
            this.setUiConfigHide(k.name, k.hideMe);
        });
        super.initApplyStoreToDynamic(applyStoreToDynamic);
    }

    override initRegisterDynamic() {
        const resolution: FieldConfig = {
            type: "input",
            value: '',
            label: this.translocoService.translate('general.resolution', {}, this.translocoService.getActiveLang()),
            inputType: "number",
            min: 0,
            step: 1,
            name: "resolution",
            storePath: ''
        };
        const blur: FieldConfig = {
            type: "input",
            value: '',
            label: this.translocoService.translate('general.blur', {}, this.translocoService.getActiveLang()),
            inputType: "number",
            min: 0,
            step: 1,
            name: "blur",
            storePath: ''
        };
        const alpha: FieldConfig = {
            type: "input",
            value: '',
            label: this.translocoService.translate('general.alpha', {}, this.translocoService.getActiveLang()),
            inputType: "decimal",
            min: 0,
            max: 1,
            step: 0.1,
            name: "alpha",
            storePath: ''
        };
        const borderThickness: FieldConfig = {
            type: "input",
            value: '',
            label: this.translocoService.translate('general.thickness', {}, this.translocoService.getActiveLang()),
            inputType: "number",
            min: 0,
            max: 999,
            step: 1,
            name: "borderThickness",
            storePath: ''
        };
        const color: FieldConfig = {
            type: "input",
            value: '',
            label: this.translocoService.translate('general.color', {}, this.translocoService.getActiveLang()),
            inputType: "color",
            name: "color",
            storePath: ''
        };
        const borderColor: FieldConfig = {
            type: "input",
            value: '',
            label: this.translocoService.translate('general.borderColor', {}, this.translocoService.getActiveLang()),
            inputType: "color",
            name: "borderColor",
            storePath: ''
        };
        
        switch (this.effect) {
            case 'Appearance': {
                this.uiConfigInit = [
                    alpha,
                    {
                        type: "select",
                        label: this.translocoService.translate('general.blendMode', {}, this.translocoService.getActiveLang()),
                        name: "blendMode",
                        value: "",
                        ignoreMissingValue: true,
                        options: [
                            {
                                optionsLabel: 'Normal',
                                optionValue: 'normal',
                                optionType: 'text'
                            },
                            {
                                optionsLabel: 'Alpha',
                                optionValue: 'alpha',
                                optionType: 'text'
                            },
                            {
                                optionsLabel: 'Add',
                                optionValue: 'add',
                                optionType: 'text'
                            },
                            {
                                optionsLabel: 'Darken',
                                optionValue: 'darken',
                                optionType: 'text'
                            },
                            {
                                optionsLabel: 'Difference',
                                optionValue: 'difference',
                                optionType: 'text'
                            },
                            {
                                optionsLabel: 'Erase',
                                optionValue: 'erase',
                                optionType: 'text'
                            },
                            {
                                optionsLabel: 'Hardlight',
                                optionValue: 'hardlight',
                                optionType: 'text'
                            },
                            {
                                optionsLabel: 'Invert',
                                optionValue: 'invert',
                                optionType: 'text'
                            },
                            {
                                optionsLabel: 'Layer',
                                optionValue: 'layer',
                                optionType: 'text'
                            },
                            {
                                optionsLabel: 'Lighten',
                                optionValue: 'lighten',
                                optionType: 'text'
                            },
                            {
                                optionsLabel: 'Multiply',
                                optionValue: 'multiply',
                                optionType: 'text'
                            },
                            {
                                optionsLabel: 'Overlay',
                                optionValue: 'overlay',
                                optionType: 'text'
                            },
                            {
                                optionsLabel: 'Screen',
                                optionValue: 'screen',
                                optionType: 'text'
                            },
                            {
                                optionsLabel: 'Subtract',
                                optionValue: 'subtract',
                                optionType: 'text'
                            }
                        ],
                        storePath: ''
                    },
                ];
                break;
            }
            case 'Border': {
                this.uiConfigInit = [
                    borderColor,
                    borderThickness,
                ];
                break;
            }
            case 'Background': {
                this.uiConfigInit = [
                    color,
                    alpha,
                ];
                break;
            }
            case 'Blur': {
                this.uiConfigInit = [
                    {
                        type: "input",
                        value: '',
                        label: this.translocoService.translate('general.blurX', {}, this.translocoService.getActiveLang()),
                        inputType: "number",
                        min: 0,
                        step: 1,
                        name: "blurX",
                        storePath: ''
                    },
                    {
                        type: "input",
                        value: '',
                        label: this.translocoService.translate('general.blurY', {}, this.translocoService.getActiveLang()),
                        inputType: "number",
                        min: 0,
                        step: 1,
                        name: "blurY",
                        storePath: ''
                    },
                    resolution,
                ];
                break;
            }
            case 'Shadow': {
                this.uiConfigInit = [
                    color,
                    alpha,
                    blur,
                    {
                        type: "input",
                        value: '',
                        label: this.translocoService.translate('general.angle', {}, this.translocoService.getActiveLang()),
                        inputType: "number",
                        min: 0,
                        step: 1,
                        name: "angle",
                        storePath: ''
                    },
                    {
                        type: "input",
                        value: '',
                        label: this.translocoService.translate('general.distance', {}, this.translocoService.getActiveLang()),
                        inputType: "number",
                        min: 0,
                        step: 1,
                        name: "distance",
                        storePath: ''
                    },
                    {
                        type: "input",
                        value: '',
                        label: this.translocoService.translate('general.resolution', {}, this.translocoService.getActiveLang()),
                        inputType: "number",
                        min: 0,
                        step: 1,
                        name: "resolution",
                        storePath: ''
                    },
                    {
                        type: "input",
                        value: '',
                        label: this.translocoService.translate('general.blurX', {}, this.translocoService.getActiveLang()),
                        inputType: "number",
                        min: 0,
                        step: 1,
                        name: "blurX",
                        storePath: ''
                    },
                    {
                        type: "input",
                        value: '',
                        label: this.translocoService.translate('general.blurY', {}, this.translocoService.getActiveLang()),
                        inputType: "number",
                        min: 0,
                        step: 1,
                        name: "blurY",
                        storePath: ''
                    },
                    {
                        type: "input",
                        value: '',
                        label: this.translocoService.translate('general.strength', {}, this.translocoService.getActiveLang()),
                        inputType: "number",
                        min: 0,
                        step: 1,
                        name: "strength",
                        storePath: ''
                    },
                ];
                break;
            }
            case 'Glow': {
                this.uiConfigInit = [
                    color,
                    alpha,
                    blur,
                    resolution,
                ];
                break;
            }
            case 'Gradient': {
                this.uiConfigInit = [
                    {
                        type: "input",
                        value: '',
                        label: this.translocoService.translate('general.color', {}, this.translocoService.getActiveLang()),
                        inputType: "color",
                        name: "color0",
                        storePath: ''
                    },
                    {
                        type: "input",
                        value: '',
                        label: this.translocoService.translate('general.alpha', {}, this.translocoService.getActiveLang()),
                        inputType: "decimal",
                        min: 0,
                        max: 1,
                        step: 0.1,
                        name: "alpha0",
                        storePath: ''
                    },
                    {
                        type: "input",
                        value: '',
                        label: this.translocoService.translate('general.color', {}, this.translocoService.getActiveLang()),
                        inputType: "color",
                        name: "color1",
                        storePath: ''
                    },
                    {
                        type: "input",
                        value: '',
                        label: this.translocoService.translate('general.alpha', {}, this.translocoService.getActiveLang()),
                        inputType: "decimal",
                        min: 0,
                        max: 1,
                        step: 0.1,
                        name: "alpha1",
                        storePath: ''
                    },
                    {
                        type: "input",
                        value: '',
                        label: this.translocoService.translate('general.color', {}, this.translocoService.getActiveLang()),
                        inputType: "color",
                        name: "color2",
                        storePath: ''
                    },
                    {
                        type: "input",
                        value: '',
                        label: this.translocoService.translate('general.alpha', {}, this.translocoService.getActiveLang()),
                        inputType: "decimal",
                        min: 0,
                        max: 1,
                        step: 0.1,
                        name: "alpha2",
                        storePath: ''
                    },
                    {
                        type: "input",
                        value: '',
                        label: this.translocoService.translate('general.color', {}, this.translocoService.getActiveLang()),
                        inputType: "color",
                        name: "color3",
                        storePath: ''
                    },
                    {
                        type: "input",
                        value: '',
                        label: this.translocoService.translate('general.alpha', {}, this.translocoService.getActiveLang()),
                        inputType: "decimal",
                        min: 0,
                        max: 1,
                        step: 0.1,
                        name: "alpha3",
                        storePath: ''
                    },
                ];
                break;
            }
        }
    }

    override submit(formValues) {
        return super.submit(formValues);
    }

    devExportConfig() {
        const value: IEffectTypeAny = _.get(this.sceneItem, `Data[0].${this.effect}[0]`);
        const animation: IEffectTypeAny = _.cloneDeep(value);
        animation.$.name = 'name here';
        animation.$.image = 'image.gif';
        console.log(JSON.stringify(animation));
    }
}


